import { useState } from "react";
import { GoPlusCircle } from "react-icons/go";
import { IoIosCloseCircleOutline } from "react-icons/io";




const faqs = [
    {
        q: "What is the role of WhatsApp in assisting businesses to connect with more customers at the appropriate time?",
        a: "WhatsApp helps businesses send timely information, promotions, and notifications to customers. This increases awareness, engagement, and conversion rates by enabling instant and direct communication."
    },
    {
        q: "Why is a chatbot used in real estate?",
        a: "A real estate chatbot is an automated WhatsApp assistant that answers property-related questions, shares listings, qualifies leads, and helps buyers or tenants receive immediate and accurate information."
    },
    {
        q: "Is it possible to use WhatsApp automation to make appointments?",
        a: "Yes, WhatsApp automation can automatically handle appointment scheduling, confirmations, rescheduling, and reminders without the need for human intervention."
    },
    {
        q: "Can medicine or medical test reminders be sent through WhatsApp?",
        a: "Yes, WhatsApp automation allows clinics and healthcare providers to send timely medication, visit, and medical test reminders to ensure better organization for both patients and staff."
    },
    {
        q: "What is the meaning of WhatsApp Automation?",
        a: "WhatsApp automation is the process of automatically sending messages, responding to inquiries, managing conversations, and streamlining customer communication using tools and software."
    },
    {
        q: "Is using bulk messages on WhatsApp legal and compliant with platform policies?",
        a: "Yes, bulk messaging is legal when using approved WhatsApp marketing tools, following opt-in rules, and complying with WhatsApp’s terms of service and data protection guidelines."
    }
];


export default function FAQContactSection() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    

    return (
        <section className="py-5 font-inter" style={{ background: 'linear-gradient(to bottom, #02151B, #088757)' }}>
            <header className="text-center mb-5">
                <h2 className="display-7 fw-semibold text-white font-bricolage">
                    Frequently Asked Questions
                </h2>
            </header>

            <div className="container py-5" style={{ maxWidth: '1024px' }}>
                <div className="rounded-3 p-1" style={{ background: 'linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))' }}>
                    <div className="rounded-3 bg-transparent">
                        {faqs.map((item, index) => (
                            <div
                                key={index}
                                className="position-relative py-4"
                            >
                                
                                {index !== faqs.length - 1 && (
                                    <div
                                        className="position-absolute bottom-0 start-0 w-100"
                                        style={{ height: '1px', background: 'linear-gradient(to right, #F6F6F6, rgba(246, 246, 246, 0))' }}
                                    ></div>
                                )}

                              
                                <div
                                    onClick={() => toggleFAQ(index)}
                                    className="d-flex justify-content-between align-items-center cursor-pointer px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <p className={`h5 mb-0 font-bricolage fw-medium transition-all ${openIndex === index ? "text-yellowgreen" : "text-white"}`}
                                        style={{ color: openIndex === index ? '#C7EB4F' : '#ffffff' }}>
                                        {item.q}
                                    </p>

                                    <span className="fs-3 text-white border rounded-circle d-flex align-items-center justify-content-center p-1"
                                        style={{ backgroundColor: 'rgba(0, 50, 0, 0.1)', borderColor: 'rgba(255,255,255,0.1)' }}>
                                        {openIndex === index ? (
                                            <IoIosCloseCircleOutline size={20} />
                                        ) : (
                                            <GoPlusCircle size={20} />
                                        )}
                                    </span>
                                </div>

                                
                                <div
                                    className="overflow-hidden px-3 transition-all"
                                    style={{
                                        transition: 'all 0.3s ease-in-out',
                                        maxHeight: openIndex === index ? '200px' : '0',
                                        marginTop: openIndex === index ? '1rem' : '0',
                                        opacity: openIndex === index ? 1 : 0
                                    }}
                                >
                                    <p className="text-white-50 mb-0 fs-6 fs-md-5 pe-4">
                                        {item.a}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
